import client from "./client";

export function getEmailTemplates(params = {}) {
    return client.get("/api/email-templates", { params });
}

export function getEmailTemplate(id) {
    return client.get(`/api/email-templates/${id}`);
}

export function createEmailTemplate(data) {
    return client.post("/api/email-templates", data);
}

export function updateEmailTemplate(id, data) {
    return client.put(`/api/email-templates/${id}`, data);
}

export function deleteEmailTemplate(id) {
    return client.delete(`/api/email-templates/${id}`);
}

export function sendEmailTemplate (id, data) {
    return client.post(`/api/email-templates/${id}/send`, data);
}